// extracted by mini-css-extract-plugin
export default {"selectBox":"SortSelectBox_selectBox__fxaSt","active":"SortSelectBox_active__ptYDO"};